import React, { useState, useEffect } from 'react';
import { DataTable, Filter, PageWrapper } from '../../components';
import { getAdminList } from "../../api/admin";
import { Dropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../../shared/enums';
import { useTranslation } from 'react-i18next';
import { RiAddLargeLine } from 'react-icons/ri';
import Button from '../../components/common/Button';

const Admin = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    const [filter, setFilter] = useState({});
    const [pagination, setPagination] = useState({ page: 1, pageSize: 25 });
    const [totalPages, setTotalPage] = useState(0);
    const [data, setData] = useState([]);

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
        setPagination(prev => ({ ...prev, page: 1 })); // Reset to page 1 when filter changes
    };

    const columns = [
        { key: "fullName", label: t("FULL_NAME"), },
        { key: "phoneNumber", label: t("PHONE_NUMBER"), render: (phoneNumber, data) => data.countryCode + data.phoneNumber },
        { key: "email", label: t("EMAIL") },
        { key: "gender", label: t("GENDER") },
        { key: "referenceNumber", label: t("REFERENCE_NUMBER") },
        { key: "serviceAreas", label: t("SERVICE_AREAS"), render: (serviceAreas = []) => serviceAreas.length > 0 ? serviceAreas.join(", ") : "-" },
        { key: "suspended", label: t("SUSPENDED"), render: (suspended) => suspended.toString() },
        {
            key: "action", label: t("ACTION"), render: (v, data) => <Dropdown>
                <Dropdown.Toggle variant="primary" size="sm" className='py-0'></Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => navigate(Pages.AdminDetail.replace(":id", data.id))}>{t("EDIT")}</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        }
    ]

    const filters = [
        { type: "input", label: t("SEARCH"), name: "search" },
        { type: "select", label: t("SUSPENDED"), name: "suspended", options: [{ label: "All", value: "" }, { label: "Yes", value: true }, { label: "No", value: false }] }
    ]

    useEffect(() => {
        getData(pagination, filter)
    }, [pagination, filter])

    const getData = async (pagination, filter) => {
        const response = await getAdminList({ skip: (pagination?.page - 1) * pagination?.pageSize, limit: pagination?.pageSize, ...filter })
        setData(response.items)
        setTotalPage(Math.ceil(response?.pagination?.total / pagination?.pageSize))
    }

    return (
        <PageWrapper
            headerProps={{
                title: "ADMIN",
                rightElement: <Button icon={<RiAddLargeLine />} onClick={() => navigate(Pages.AdminDetail.replace(":id", "new"))}>{t("ADD")}</Button>
            }}
        >
            <Filter filters={filters} onChangeFilter={handleFilterChange} />
            <DataTable columns={columns} data={data} pagination={{ ...pagination, totalPages, onChange: setPagination }} />
        </PageWrapper>
    );
};

export default Admin;
